module.exports = __webpack_public_path__ + "static/media/edit.e9024d3f.svg";